var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.tableGeneric = function (widget, chart, data, metadata, renderImpl) {
    var isScaled = renderImpl(widget, chart, data, metadata);
    
    if (isScaled !== true && metadata.KendoConfig && metadata.KendoConfig.autoScaleHeight) {
        //Scale widget height according to the table it contains
        var fullHeight = widget.find('table').height() + widget.find('.box-header').outerHeight();
        widget.find('.box-primary').height(fullHeight);
    }
};